import { Avatar, Grid, TableCell, TableRow } from '@mui/material';
import React from 'react';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import CodeQrComponent from '../../../usuario/usu_entidades/components/code_qr';

const ExpandedEquiposComponent = ({ data, rowData }) => {
  return (
    <TableRow>
      <TableCell colSpan={rowData.length} sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={12} md={2}>
            <Avatar
              alt={data.imagen}
              sx={{ width: 150, height: 150 }}
              src={getFilesArchivos(data.imagen)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <strong>Descripción:</strong>
            <br />
            {data.desc || 'Sin descripción'}
          </Grid>
          <Grid item xs={12} md={4} align="center">
            <strong>Fecha de creación:</strong>
            <br />
            {data.createdAt}
            <br />
            <strong>Fecha de edición:</strong>
            <br />
            {data.updatedAt}
          </Grid>
          <Grid item xs={12} md={2} align="end">
            <CodeQrComponent
              size={50}
              maxWidth="140px"
              value={`${data.codeqr}`}
            />
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedEquiposComponent;
